import { h } from 'preact';
import dlv from 'dlv';
import cx from 'classnames';

import style from './style';
import pageStyles from '../../../pageStyles';

import SimpleGridCluster from '../../../../clusters/simple-grid-cluster';
import CategoryCluster from '../../../../clusters/category-cluster';
import TopSearchesCluster from '../../../../clusters/top-searches-cluster';
import { SadlibAd } from '../../../../pieces/sadlib-ad';
import { Header, Footer } from '../../../shared/desktop';
import { getCommonProps } from '../../../../../lib/page';
import { WeatherWidget } from '@cube/weather-widget';
import { StocksWidget } from '@cube/finance-components';
import { Column, ColumnSticky, Row, Section, ContainerFluid } from '@cube/layout';
import Notifications from '@cube/notifications';

export const Desktop = ({ pageConfig, clientDisplayName, ...props }) =>
	(
		<ContainerFluid class={pageStyles.fluidPageNoPadding}>
			<Header
				pageConfig={pageConfig}
				{...props}
			/>
			<Section containerClass={pageStyles.defaultPageWidth}>
				<Notifications
					alertClass={style.notification}
					{...getCommonProps(props)}
				/>
				<SadlibAd id="sc_home_header_banner" type="desktopBanner" />
			</Section>
			<Section containerClass={pageStyles.defaultPageWidth}>
				<Row class={style.heroRow}>
					<Column>
						<CategoryCluster
							{...dlv(pageConfig, 'clusters.hero')}
							topCardClass="yeehaw"
							qeId="sc-home-hero"
							{...getCommonProps(props)}
						/>
						<SimpleGridCluster
							{...dlv(pageConfig, 'clusters.todaysStories')}
							qeId="sc-home-todaysStories"
							{...getCommonProps(props)}
						/>
					</Column>
					<ColumnSticky class={cx(pageStyles.smallFixedRightColumn, style.rightRail)}>
						<TopSearchesCluster
							{...dlv(pageConfig, 'clusters.trendingSearches')}
							{...getCommonProps(props)}
						/>
						<SadlibAd id="sc_home_hero_sidebar" type="desktopRail" />
						<WeatherWidget
							titleIcon="umbrella-cube"
							{...getCommonProps(props)}
						/>
						<SimpleGridCluster
							{...dlv(pageConfig, 'clusters.featuredGames')}
							cardClass="oneLineMetadata"
							qeId="sc-home-featuredGames"
							{...getCommonProps(props)}
						/>
						<SadlibAd id="sc_home_entertainment_sidebar" type="desktopRail" />
						<StocksWidget
							titleIcon="corporate-wire-cube"
							{...getCommonProps(props)}
						/>
						<SadlibAd id="sc_home_sports_sidebar" type="desktopRail" />
					</ColumnSticky>
				</Row>
			</Section>
			<Footer
				pageConfig={pageConfig}
				{...getCommonProps(props)}
			/>
		</ContainerFluid>
	);

